const CHECKOUT_API_URL =
  import.meta.env.VITE_CHECKOUT_API_URL ||
  import.meta.env.VITE_API_URL?.replace('/api/v1', '') ||
  'http://localhost:8787';

const BACKEND_API_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';

const WIX_STATIC_RE = /^https?:\/\/static\.wixstatic\.com\/media\/([^/]+)/;

export interface ProductDetail {
  sku: string;
  title: string | null;
  brand: string | null;
  size: string | null;
  start_price: string;
  primary_photo_url_thumb: string | null;
  primary_photo_url_full: string | null;
  site_name: string;
  isAvailable: boolean;
}

export async function fetchProductBySku(
  siteId: number,
  sku: string
): Promise<ProductDetail | null> {
  try {
    const res = await fetch(
      `${CHECKOUT_API_URL}/product/${siteId}/${encodeURIComponent(sku)}`
    );
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`Edge API error: ${res.status}`);
    const json = await res.json();
    return json.data;
  } catch {
    const res = await fetch(
      `${BACKEND_API_URL}/storefront/${siteId}/products/${encodeURIComponent(sku)}`
    );
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`API error: ${res.status}`);
    const json = await res.json();
    return json.data;
  }
}

export function wixImageUrl(baseUrl: string, width: number, height: number): string {
  const match = baseUrl.match(WIX_STATIC_RE);
  if (!match) return baseUrl;
  const mediaId = match[1];
  return `https://static.wixstatic.com/media/${mediaId}/v1/fill/w_${width},h_${height},al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/${mediaId}`;
}

export function resolvePhotoUrl(
  thumb: string | null,
  full: string | null
): string | undefined {
  const url = full || thumb;
  if (!url) return undefined;
  if (url.includes('wixstatic.com')) {
    return wixImageUrl(url, 128, 128);
  }
  return url;
}
